import Footer from "components/footer/FooterAuthDefault";
import { Link, Routes, Route, Navigate, useLocation } from "react-router-dom";
import routes from "routes.js";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";
import ForgotPassword from "views/auth/ForgotPassword";
import VerifyEmail from "views/auth/VerifyEmail";
import ResetPassword from "views/auth/ResetPassword";
import Login from "views/auth/Login";
import SignUp from "views/auth/SignIn";

const getRoutes = (allRoutes) => {
  return allRoutes.map((prop, key) => {
    if (prop.layout === "/auth") {
      return (
        <Route path={`/${prop.path}`} element={prop.component} key={key} />
      );
    }
    return null;
  });
};

function AuthShell({ entry }) {
  const location = useLocation();
  const isNavyAuthPage =
    location.pathname === "/SignIn" ||
    location.pathname === "/SignUp" ||
    location.pathname === "/PasswordRecovery" ||
    location.pathname.includes("/auth/verify-email") ||
    location.pathname.includes("/auth/reset-password");

  const brandPanelClassName =
    "flex min-h-full w-full flex-1 flex-col items-center justify-center gap-1 bg-gradient-to-br from-[#1b2bff] via-[#2436ff] to-[#0b1437] px-4 text-white md:rounded-bl-[120px] xl:rounded-bl-[200px]";

  document.documentElement.dir = "ltr";
  return (
    <div>
      <div
        className={`relative float-right h-full min-h-screen w-full ${
          isNavyAuthPage
            ? "bg-[#0B1437]"
            : "!bg-white dark:!bg-navy-900"
        }`}
      >
        {!isNavyAuthPage && <FixedPlugin />}
        <main className={`mx-auto min-h-screen`}>
          <div className="relative flex">
            <div className="mx-auto flex min-h-full w-full flex-col justify-start pt-12 md:max-w-[75%]  lg:max-w-[1013px] lg:px-8 lg:pt-0 xl:min-h-[100vh] xl:max-w-[1383px] xl:px-0 xl:pl-[70px]">
              <div className="flex w-full min-w-0 flex-1 flex-col md:flex-row md:items-stretch">
                <div className="relative z-30 mb-auto flex min-h-0 min-w-0 flex-1 flex-col pl-5 pr-5 md:pl-12 md:pr-8">
                  {entry === "signin" ? (
                    <Login />
                  ) : entry === "signup" ? (
                    <SignUp />
                  ) : entry === "forgot" ? (
                    <ForgotPassword />
                  ) : location.pathname.includes("/auth/verify-email") ? (
                    <VerifyEmail />
                  ) : location.pathname.includes("/auth/reset-password") ? (
                    <ResetPassword />
                  ) : (
                    <Routes>
                      {getRoutes(routes)}
                      <Route
                        path="/"
                        element={<Navigate to="/SignIn" replace />}
                      />
                    </Routes>
                  )}
                </div>
                <div className="relative z-0 hidden w-full shrink-0 md:flex md:min-h-screen md:w-[min(49vw,720px)] md:flex-col 2xl:w-[min(44vw,680px)]">
                  <div className={brandPanelClassName}>
                    <Link
                      to="/"
                      aria-label="Home"
                      className="flex w-full max-w-[980px] justify-center"
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/AlphaSniperTradingLogo_sans_ecriture_sharpened-removebg-preview.png?v=20260501c`}
                        alt="AlphaSniper Trading Logo"
                        className="h-auto max-h-[72vh] w-full object-contain drop-shadow-[0_18px_36px_rgba(0,0,0,0.45)]"
                      />
                    </Link>
                    <Link
                      to="/"
                      aria-label="Home"
                      className="-mt-20 flex w-[220%] max-w-none justify-center"
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/AlphaSniperTrading-Black-RBG.png?v=20260501h`}
                        alt="AlphaSniper Trading"
                        className="h-auto max-h-[46vh] w-full object-contain brightness-110 contrast-110 drop-shadow-[0_8px_20px_rgba(0,0,0,0.35)]"
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export function AuthSignIn() {
  return <AuthShell entry="signin" />;
}

export function AuthSignUp() {
  return <AuthShell entry="signup" />;
}

export function AuthPasswordRecovery() {
  return <AuthShell entry="forgot" />;
}

export default function Auth() {
  return <AuthShell entry={null} />;
}
